import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils';
const AI_BUILDER_ASSISTANT_MESSAGE_FRAME_CLASS_NAME = 'flex w-full max-w-[484px] flex-col items-start pb-md pl-sm pr-2xl';
const AI_BUILDER_ASSISTANT_MESSAGE_DEFAULT_CONTENT_CLASS_NAME = 'flex w-full flex-col items-start gap-2xs';
export const AiBuilderAssistantMessageFrame = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn(AI_BUILDER_ASSISTANT_MESSAGE_FRAME_CLASS_NAME, className)} data-ai-assistant-message-frame {...props} data-sentry-component="AiBuilderAssistantMessageFrame" data-sentry-source-file="AiBuilderAssistantMessageFrame.tsx">
      <div className={AI_BUILDER_ASSISTANT_MESSAGE_DEFAULT_CONTENT_CLASS_NAME} data-ai-assistant-default-content>
        {children}
      </div>
    </div>;
};